import { MsalProvider, useMsal } from "@azure/msal-react";
import { ThemeProvider } from "@mui/material/styles";
import { getGroupInfo, loginRequest, msalInstance } from "auth/MsalAuth";
import { getTheme } from "config/styles/getTheme.js";
import ForceReload from "pages/force-redirect";
import Mainpage from "pages/main";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AthenaGroupId, AthenaUrl, HAIGroupId, HAIGroupIdProd, HaiUrl } from "./commonConstants.js";

const validateUser = async (UserName, UserToken, setAccessDenied, setRoleChecked) => {
  const currentENV = process.env.REACT_APP_ENV;
  if (!UserName?.toLowerCase()?.endsWith("@kantar.com")) {
    const GroupInfo = await getGroupInfo(UserToken);
    if (!GroupInfo?.value.length) {
      setAccessDenied(true);
      setRoleChecked(true);
    } else {
      if (
        GroupInfo?.value.includes(AthenaGroupId) &&
        GroupInfo?.value.includes(currentENV === "PROD" ? HAIGroupIdProd : HAIGroupId)
      ) {
        setAccessDenied(false);
        setRoleChecked(true);
        return;
      }
      GroupInfo?.value.includes(AthenaGroupId)
        ? window.location.replace(window.location.origin + AthenaUrl)
        : GroupInfo?.value.includes(HAIGroupId)
        ? window.location.replace(window.location.origin + HaiUrl)
        : setRoleChecked(true);
      setAccessDenied(true);
    }
  } else {
    setAccessDenied(false);
    setRoleChecked(true);
  }
};

const NavigationTab = () => {
  const { instance } = useMsal();
  const [accessDenied, setAccessDenied] = React.useState(false);
  const [roleChecked, setRoleChecked] = React.useState(false);

  React.useEffect(() => {
    const login = async () => {
      await instance.initialize();
      const UserName = sessionStorage.getItem("msalUsername");
      const UserToken = sessionStorage.getItem("msalToken");

      if (UserName && UserToken) {
        validateUser(UserName.toLowerCase(), UserToken, setAccessDenied, setRoleChecked);
        return;
      }
      await instance
        .handleRedirectPromise()
        .then((response) => {
          if (instance.getAllAccounts().length > 0) {
            sessionStorage.setItem("msalUsername", response?.account?.username?.toLowerCase());
            sessionStorage.setItem("msalToken", response?.accessToken);
            return response;
          } else {
            return instance.loginRedirect(loginRequest);
          }
        })
        .then((response) =>
          validateUser(response?.account.username.toLowerCase(), response?.accessToken, setAccessDenied, setRoleChecked)
        )
        .catch((err) => console.error(err));
    };
    login();
  }, [instance]);

  if (
    (sessionStorage.getItem("msalToken") === null || sessionStorage.getItem("msalToken") === undefined) &&
    roleChecked
  )
    return null;

  if (roleChecked) {
    return (
      <React.Suspense fallback={null}>
        <div className="App">
          <ThemeProvider theme={getTheme()}>
            <ErrorBoundary FallbackComponent={() => <div>Error loading</div>}>
              <BrowserRouter>
                <Routes path="/" element={<Mainpage />}>
                  <Route index element={<Mainpage accessDenied={accessDenied} />} />
                  <Route path="hai" element={<ForceReload />} />
                  <Route path="/*" element={<Navigate to="/" />} />
                </Routes>
              </BrowserRouter>
            </ErrorBoundary>
          </ThemeProvider>
        </div>
      </React.Suspense>
    );
  }
};

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <NavigationTab />
    </MsalProvider>
  );
}

export default App;
